import { useFormContext } from 'react-hook-form';
import { useEffect, useRef } from 'react';
import { ReservationLinkResult } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { createOption, LocalizedDateFromUtc } from '@mews-commander/ui';
import { SelectField } from '@mews-commander/form';
import { CreatePaymentPlanFormField } from '../types';
import { useGetReservationPaymentPlanStartDatesUtc } from '../hooks';
import { CreatePaymentPlanFormValues } from '../schema';

export const CreatePaymentPlanDialogDateSelectField = ({ reservation }: { reservation: ReservationLinkResult }) => {
    const { setValue, getValues } = useFormContext<CreatePaymentPlanFormValues>();

    const paymentPlanStartDatesUtc = useGetReservationPaymentPlanStartDatesUtc(reservation);
    const reservationRef = useRef(reservation);

    useEffect(() => {
        if (
            paymentPlanStartDatesUtc.length === 0 ||
            (getValues(CreatePaymentPlanFormField.StartDateUtc) && reservationRef.current === reservation)
        ) {
            return;
        }

        // sets the default value only when the field has no value or when the reservation has changed
        setValue(CreatePaymentPlanFormField.StartDateUtc, paymentPlanStartDatesUtc[0]);
        reservationRef.current = reservation;
    }, [setValue, getValues, paymentPlanStartDatesUtc, reservation]);

    const options = paymentPlanStartDatesUtc.map((dateUtc) =>
        createOption({
            value: dateUtc,
            label: <LocalizedDateFromUtc utcString={dateUtc} />,
        })
    );

    return (
        <SelectField
            name={CreatePaymentPlanFormField.StartDateUtc}
            label={lt('CreatePaymentPlanFormStartDateLabel')}
            required
            options={options}
        />
    );
};
